import React from 'react';
import { Navigate } from 'react-router-dom';

export const redirectFromHashLinks = () => {
  const url = window.location.href;
  const arr = url.split('/');
  const id = arr[5];
  const link = (path) => (id ? `${path}/${id}` : path);

  switch (arr[4]) {
    case '#home':
      return <Navigate to={{ pathname: '/' }} />;
    case '#dossiers':
      return <Navigate to={{ pathname: link('/portfolios') }} />;
    case '#analysts':
      return <Navigate to={{ pathname: link('/analysts') }} />;
    case '#entities':
      return <Navigate to={{ pathname: link('/entities') }} />;
    case '#newscentre':
      return <Navigate to={{ pathname: link('/news-centre') }} />;
    case '#instruments':
      return <Navigate to={{ pathname: link('/instruments') }} />;
    case '#announcements':
      return <Navigate to={{ pathname: link('/announcements') }} />;
    default:
      return null;
  }
};
